import React from 'react';
import { SectionContainer } from '@/components';
import { formatMessage } from '@/locales';
import './home-banner.view.less';

import LogoImage from '@/assets/img/home/banner/habby@2x.png';

const BannerView = () => {
    return (
        <SectionContainer
            className="home-banner-view"
            imageRender={() => {
                return (
                    <picture>
                        <source
                            srcSet={require('@/assets/img/home/banner/home_page_banner@768.png')}
                            media="(max-width: 768px)"
                        />
                        <img
                            className="background-image"
                            src={require('@/assets/img/home/banner/background.png')}
                            alt=""
                        />
                    </picture>
                );
            }}
        >
            <div className="content">
                <div className="logo-wrapper">
                    <img src={LogoImage} alt="" />
                </div>
                <p className="desc">
                    {formatMessage({ id: 'home.banner.description' })}
                </p>
            </div>
        </SectionContainer>
    );
};

export default BannerView;
